module.exports = __webpack_public_path__ + "static/img/200058.b17be059.png";